import React from 'react';
import { CLOSING } from '../../data/content';

export default function Closing() {
  return (
    <section id="closing" style={{ background: '#06410A', padding: '72px 0', textAlign: 'center' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>

        <div className="r25-closing-logo" style={{ fontFamily: 'var(--serif)', fontSize: 52, color: '#fff', marginBottom: 10, fontWeight: 600, letterSpacing: -1 }}>
          humd
        </div>
        <div style={{ fontSize: 15, color: 'var(--g5)', fontStyle: 'italic', fontFamily: 'var(--serif)', marginBottom: 40 }}>
          The business is better positioned today than it has ever been.
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 520, margin: '0 auto 40px', textAlign: 'left' }}>
          {CLOSING.points.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: 12, fontSize: 14, color: 'rgba(255,255,255,0.7)' }}>
              <span style={{ color: 'var(--g2)', fontWeight: 700, flexShrink: 0 }}>&#10003;</span>
              {p}
            </div>
          ))}
        </div>

        <div style={{ fontFamily: 'var(--serif)', fontSize: 22, color: 'var(--g5)', marginBottom: 4, fontWeight: 600 }}>
          {CLOSING.sig}
        </div>
        <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', marginBottom: 24 }}>
          {CLOSING.sigSub}
        </div>

        <div className="r25-closing-links" style={{ fontSize: 14, color: 'var(--g5)' }}>
          <a href={`mailto:${CLOSING.email}`} style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>{CLOSING.email}</a>
          {CLOSING.domains.map((d, i) => (
            <span key={i}>
              <span className="r25-link-sep">{' '}&nbsp;·&nbsp;{' '}</span>
              <a href={d.url} target="_blank" rel="noreferrer" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>{d.label}</a>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
